//A collection of functions that are used on most Vici web apps
//v0.1
const viciCommon = {
	//This will override console to log to lumberjack via a websocket
	//Call it with console = await viciCommon.initLogSocket('wss://lj.vicinft.com/lumberjack/ws', 'App Name');
	logSocket: false,
	initLogSocket: async function(lumberjackLocation, appName, id){
		let resolver;
		viciCommon.logSocket = new WebSocket(lumberjackLocation, "message");
		let bid;

		if(id){
			bid=id;
			document.cookie = "bid="+id+"; SameSite=None; Secure";
		}else{
			bid = document.cookie.split("; ").find((row) => row.startsWith("bid="))?.split("=")[1];
			if(!bid){
				bid = viciCommon.randomString(32, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
				document.cookie = "bid="+bid+"; SameSite=None; Secure";
			}
		}

		this.logSocket.onopen = (event) => {
			clearInterval(this.timerId);
			viciCommon.logSocket.onclose = () => {
				this.timerId = setInterval(() => {
					this.initLogSocket();
				}, 10000);
			};

			console = {
				log : function(msg) {
					if(viciCommon.logSocket){
						viciCommon.logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'log', message: JSON.stringify(msg), bid: bid}))
					}else{
						viciCommon.logSocket = new WebSocket(lumberjackLocation, "message");
					}
				},
				info : function(msg) {
					viciCommon.logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'info', message: JSON.stringify(msg), bid: bid}))
				},
				warn : function(msg) {viciCommon.logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'warn', message: JSON.stringify(msg), bid: bid}))},
				error : function(msg) {
					if(viciCommon.logSocket){
						viciCommon.logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'error', message: JSON.stringify(msg), bid: bid}))
					}else{
						viciCommon.logSocket = new WebSocket(lumberjackLocation, "message");
					}
				},
				debug : function(msg) {viciCommon.logSocket.send(JSON.stringify({userAgent: window.navigator.userAgent, domain: window.location.hostname, path: window.location.pathname, app: appName, type: 'debug', message: JSON.stringify(msg), bid: bid}))},
			};
			//console.log("Logsocket open");
			resolver(console);
		};


		this.logSocket.onerror = () => {
			logSocket.close();
		};

		return new Promise(resolve => {
			resolver = resolve;
		});
	},



	randomString: function(length, chars) {
		var result = '';
		for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
		return result;
	},

	sleep: function(ms){
		return new Promise(resolve => setTimeout(resolve, ms));
	},

	//Modal functions
	showModal: function(modalHtml, hideClose){
		$('#modal_text').html(modalHtml);
		if(hideClose){
			$('#modal_close').hide();
		}else{
			$('#modal_close').show();
		}

		$('#modal_grey').show();
		$('#modal').show();

		$("#modal_grey").click(function() {
			viciCommon.hideModal();
		});


		$('#modal_close').click(this.hideModal);
	},

	hideModal: function(){
		$('#modal_grey').hide();
		$('#modal').hide();
		$('#modal_text').html('');
	},


	//Message display queue (toaster)
	//If you want to skip the full sleep time you can use nextMessage()
	//So the idea is to start with a long display time and then resolve early
	//If you call nextMessage(true) it will clear, even if there is nothing in the queue before
	//Otherwise it will keep showing
	sleepPromise: undefined,
	sleepPromiseResolve: undefined,
	sleepPromiseReject: undefined,
	sleepTimeout: undefined,
	messageSleeping: false,
	messages : [],
	messagesShowing : false,

	messageSleep: function(ms){
		this.messageSleeping = true;
		this.sleepPromise = new Promise(function(resolve, reject){
			viciCommon.sleepPromiseResolve = resolve;
			viciCommon.sleepPromiseReject = reject;
			viciCommon.sleepTimeout = setTimeout(viciCommon.sleepPromiseResolve, ms)
		}).finally(() =>{this.messageSleeping=false});
		return this.sleepPromise;
	},

	nextMessage: async function(clearMessage){
		if(!clearMessage || clearMessage!==true){
			if(this.messages.length<1){
				return;
			}
		}
		if(this.messagesShowing){
			if(this.sleepPromiseResolve){
					while(this.messageSleeping===false){
					await this.sleep(100);
				}
				this.sleepPromiseResolve();
				clearTimeout(viciCommon.sleepTimeout);
			}else{
				while(this.sleepPromiseResolve==undefined){
					await this.sleep(100);
				}
				this.sleepPromiseResolve();
				clearTimeout(viciCommon.sleepTimeout);
			}
		}
	},

	addMessage: async function(message, type, ms){
		$("#message").removeClass();
		$("#message").addClass(type);
		$('#message').html(message)
		$('#message').show();
	},

	hideMessage: async function(){
		$('#message').hide();
	},

	convertENotationToNumber: function(num) {
	    const str = num.toString()
		const match = str.match(/^(\d+)(\.(\d+))?[eE]([-\+]?\d+)$/)
		if (!match) return str //number was not e notation or toString converted
		// we parse the e notation as (integer).(tail)e(exponent)
		const [, integer,, tail, exponentStr ] = match
		const exponent = Number(exponentStr)
		const realInteger = integer + (tail || '')
		if(exponent > 0) {
			const realExponent = Math.abs(exponent + integer.length)
			return realInteger.padEnd(realExponent, '0')
		} else {
			const realExponent = Math.abs(exponent - (tail?.length || 0))
			return '0.'+ realInteger.padStart(realExponent, '0')
		}
	},
	viciAlert: async function(message){
		let resolver;
		$('#alert_text').html(message);
		$('#modal_grey').show();
		$('#alert').show();
		$('#alert_buttons').html('<button id="alert_ok">OK</button>');
		
		$('#alert_ok').click(async function() {
			$('#alert_text').html('');
			$('#modal_grey').hide();
			$('#alert').hide();
			resolver();
		})
		return new Promise(resolve => {
			resolver = resolve;
		});
		
	},
	viciConfirm: async function(message){
		let resolver;
		$('#alert_text').html(message);
		$('#modal_grey').show();
		$('#alert').show();
		$('#alert_buttons').html('<button id="alert_ok">OK</button> <button id="alert_cancel">Cancel</button>');
		
		$('#alert_ok').click(async function() {
			$('#alert_text').html('');
			$('#modal_grey').hide();
			$('#alert').hide();
			resolver(true);
		})
		$('#alert_cancel').click(async function() {
			$('#alert_text').html('');
			$('#modal_grey').hide();
			$('#alert').hide();
			resolver(false);
		})
	
	
		return new Promise(resolve => {
			resolver = resolve;
		});
		
	},
}

export default viciCommon;
//module.exports = viciCommon;